$(document).ready(function () {
    setupButtons();

    function setupButtons() {
        var btns = $('[class*=baptist-btn-]');

        $(btns).each(function () {
            // Only wrap if it's not already wrapped by a single span
            var $this = $(this);
            var children = $this.contents();

            // Check if it's already wrapped in a single span (optional guard)
            if (children.length === 1 && children[0].nodeName === "SPAN") {
                return; // already wrapped
            }

            // Wrap all inner content in a new span
            var wrapper = $("<span></span>");
            children.appendTo(wrapper);
            $this.empty().append(wrapper);
        });
    }
});
